<p-toast></p-toast>
<div>
    <div class="own-mi-farmer-details card" #targetTable>
        <form [formGroup]="ownMIfarmerDetailsForm" (ngSubmit)="onSubmitfarmerOwnMIDetails()">
            <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Fill details on behalf of farmer for NOC' | translate }}</p>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <label for="appNo">{{'Tubewell App No (UHBVN/ DHBVN)' | translate}}</label>
                    <input id="appNo" type="text" pInputText formControlName="appNo">
                    <div *ngIf="ownMIfarmerDetailsForm.controls['appNo'].invalid && ownMIfarmerDetailsForm.controls['appNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['appNo'].errors.required">
                            {{'APPLICATION_NO_IS_REQUIRED' | translate}}</div>
                    </div>
                </div>

                <!-- <div class="col-12 md:col-3">
                    <p-dropdown [options]="jeList" [(ngModel)]="selectedJE"
                        placeholder="{{ 'Next User'| translate }}" optionLabel="UserID" class="mr-3">
                    </p-dropdown>
                </div> -->

                <div class="field col-12 md:col-4">
                    <label htmlFor="component">{{'PV Assign To'| translate}}</label>
                    <p-dropdown [options]="jeList" formControlName="je"
                        placeholder="{{ 'Next User'| translate }}" optionLabel="UserID" optionValue="UserID" class="mr-3">
                    </p-dropdown>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['je'].invalid && ownMIfarmerDetailsForm.controls['je'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['je'].errors.required">{{'Next user is required' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="component">{{'Remarks'| translate}}</label>
                    <textarea id="description" formControlName="remarks" placeholder="Remarks" pInputTextarea required
                        rows="2" cols="20" class="mr-3"></textarea>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['remarks'].invalid && ownMIfarmerDetailsForm.controls['remarks'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['remarks'].errors.required">{{'Remarks is required' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{'UHBVN/ DHBVN Request Letter for NOC' | translate}}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerBillDocUpload
                        (uploadHandler)="onBillUpload($event, 'nocPath', farmerBillDocUpload)" name="myfile[]"
                        [maxFileSize]="5000000" [multiple]="false" chooseLabel="{{'CHOOSE'| translate}}" [auto]="false"
                        [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <p-image *ngIf="ownMIfarmerDetailsForm.controls['nocPath'].value"
                                [src]="ownMIfarmerDetailsForm.controls['nocPath'].value" alt="Image" width="60"
                                class="ml-2" iconPos="left"></p-image>
                            <!-- <ul *ngIf="uploadedAadharFiles.length">
                            <li *ngFor="let file of uploadedAadharFiles">
                                <p-image *ngIf="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value"
                                    [src]="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                    width="60" class="ml-2" iconPos="left"></p-image>
                                {{ file.name }} - {{ file.size }} bytes
                            </li>
                        </ul> -->
                        </ng-template>
                    </p-fileUpload>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['nocPath'].invalid && ownMIfarmerDetailsForm.controls['nocPath'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['nocPath'].errors.required">
                            {{'BILL_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4 button-container-submit">
                    <label></label>
                    <div class="grid-item mt-5">
                        <button pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
                            class="p-button-success mt-2 ml-5" style="width: 100px; height: 35px; align-items: center;">
                        </button>

                        <!-- <button pButton pRipple (click)="onSubmitForm()" label="{{'SUBMIT' | translate}}" class="p-button-success"
                                style="width: 100px; height: 32px; align-items: center;">
                            </button> -->
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- <div class="button-container-submit">
        <button pButton pRipple (click)="onSubmitForm()" label="{{'SUBMIT' | translate}}" class="p-button-success"
            style="width: 100px; height: 32px; align-items: center;">
        </button>
    </div> -->
</div>